import { Box, Button, Card, Flex, FormControl, FormLabel, Input, Stack, Table, Tbody, Td, Text, Th, Thead, Tr, useColorModeValue } from "@chakra-ui/react";
import { cloneDeep } from "lodash";
import { Project } from "models/project_type";
import moment from "moment";
import Pagination from "rc-pagination";
import { useEffect, useState } from "react";
import FinanceStatus from "../../finance_project/components/FinanceStatus";

interface IAdmTable {
    list: Project[];
    showModal: (show: boolean, item: Project) => void
}
const AdmTable = ({list, showModal}: IAdmTable) => {
    const textColor = useColorModeValue("secondaryGray.900", "white");
    const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
    const countPerPage = 10;
      const [value, setValue] = useState("");
      const [currentPage, setCurrentPage] = useState(1);
      const [collection, setCollection] = useState(
        cloneDeep(list.slice(0, countPerPage))
      );
    
      const updatePage = (p: number) => {
        setCurrentPage(p);
        const to = countPerPage * p;
        const from = to - countPerPage;
        setCollection(cloneDeep(list.slice(from, to)));
      };
      const pad = (a: any, b: any) =>{
        return(1e15 + a + '').slice(-b);
      }
    
      useEffect(() => {
        const updatePage = (p: number) => {
          setCurrentPage(p);
          const to = countPerPage * p;
          const from = to - countPerPage;
          setCollection(cloneDeep(list.slice(from, to)));
        };
    
        const searchData = (val: any) => {
            const query = val.toLowerCase();
            setCurrentPage(1);
            const filteredData = list.filter(item => 
              item?.Orcamento?.cliente?.nome.toLowerCase().includes(query) ||
              item?.Orcamento?.agencia?.nome.toLowerCase().includes(query) ||
              item?.Orcamento?.Usuario?.nome.toLowerCase().includes(query)
            ).slice(0, countPerPage);
            setCollection(filteredData);
          };
        
        if (!value) {
          updatePage(1);
        } else {
          searchData(value);
        }
      }, [list, value]);
      return (
        <Card flexDirection="column" overflowX={{ sm: "scroll", lg: "hidden" }}>
          <Flex
            px="25px"
            mb="16px"
            mt="16px"
            justifyContent="space-between"
            align="center"
          >
            <Text
              color={textColor}
              fontSize="22px"
              fontWeight="700"
              lineHeight="100%"
            >
              Listagem de Projetos
            </Text>
          </Flex>
          <Box>
    
          <Stack p={4}>
              <FormControl>
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="bold"
                    color={textColor}
                    mb="8px"
    
                  >
                   Buscar
                  </FormLabel>
    
                  <Input
                    fontSize="sm"
                    ms={{ base: "0px", md: "0px" }}
                    type="text"
                    placeholder="Buscar"
                    fontWeight="500"
                    w={320}
                    size="md"
                    onChange={e => setValue(e.target.value)}
                    value={value}
                  />
                </FormControl>
              </Stack>
            <Table variant="striped" color="gray.500" mb="24px" mt="12px" id="myTable">
              <Thead>
                <Tr>
                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                    <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      #STATUS
                    </Flex>
                  </Th>
    
                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                    <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      #CÓDIGO
                    </Flex>
                  </Th>
                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                    <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      #PROJETO
                    </Flex>
                  </Th>
                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                    <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      #CADASTRO
                    </Flex>
                  </Th>
                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                    <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      #EDIÇÃO
                    </Flex>
                  </Th>
    
                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                    <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      #CLIENTE
                    </Flex>
                  </Th>
                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                    <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      #AGENCIA
                    </Flex>
                  </Th>
    
                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                    <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      #RESPONSÁVEL
                    </Flex>
                  </Th>
                  <Th pe="10px" borderColor={borderColor} cursor="pointer">
                    <Flex
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      #OPÇÕES
                    </Flex>
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                 {collection?.map((item, index) => {
                  return (
                    <Tr key={`${item?.id}-${item?.idEmpresa}-${index}`}>
                      <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                        <FinanceStatus data={item?.status}/>
                      </Td>
                      <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                        {pad(item.id, 6)}
                      </Td>
                      <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                        {item?.Orcamento?.nome}
                      </Td>
                      <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                        {moment(item?.dataCriacao).format("DD/MM/yyyy")}
                      </Td>
                      <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                        {moment(item?.dataEdicao).format("DD/MM/yyyy")}
                      </Td>
                      <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                        {item?.Orcamento?.cliente?.nome}
                      </Td>
    
                      <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                        {item?.Orcamento?.agencia?.nome}
                      </Td>
                      <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                        {item?.Orcamento?.Usuario?.nome}
                      </Td>
    
                      <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                        <Button
                          onClick={() => {
                            showModal(true, item);
                          }}
                          colorScheme="green"
                          variant="ghost"
                        >
                         GERENCIAR
                        </Button>
                      </Td>
                    </Tr>
                  );
                })} 
              </Tbody>
            </Table>
    
            <Pagination
                  pageSize={countPerPage}
                  onChange={updatePage}
                  current={currentPage}
                  total={list.length}
                  style={{
                    float : 'right',
                    marginRight :  24,
                    marginBottom: 24,
                  }}
                />
    
          </Box>
        </Card>
      );
}
export default AdmTable;